import React from 'react'
import { Flex } from '@radix-ui/themes'
import cn from 'classnames'
import { SEASON_BONUSES } from '../constants/season-bonuses'
import { RewardsProgressBarTooltip } from './rewards-progress-bar-tolltip'
import styles from '../rewards.module.scss'

interface Props {
  /** Completed challenges of the season. */
  currentStep: number
  /** Challenges of the season. */
  totalSteps: number
}

/** The cups grow from the first bonus to the last. */
const CUP_PADDINGS = ['1', '2', '3'] as const

const LAST_BONUS_STEP = Math.max(
  0,
  ...SEASON_BONUSES.map(bonus => bonus.countCompleted)
)

/** One step per challenge of the season, a cup after each bonus milestone. */
export const RewardsProgressBar: React.FC<Props> = ({
  currentStep,
  totalSteps
}) => {
  // NOTE: before the season loads, still draw every milestone
  const stepsAmount = Math.max(totalSteps, LAST_BONUS_STEP)
  const steps = Array.from({ length: stepsAmount }, (_, index) => index + 1)

  return (
    <Flex
      align={'end'}
      gap={'1'}
      role='progressbar'
      aria-label='Season progress'
      aria-valuemin={0}
      aria-valuemax={stepsAmount}
      aria-valuenow={Math.min(currentStep, stepsAmount)}
    >
      {steps.map(step => {
        const bonusIndex = SEASON_BONUSES.findIndex(
          bonus => bonus.countCompleted === step
        )
        const bonus = SEASON_BONUSES[bonusIndex]

        return (
          <React.Fragment key={step}>
            <Flex
              className={cn(styles.progressBarStep, {
                [styles.progressBarStepActive]: currentStep >= step
              })}
            />

            {bonus ?
              <RewardsProgressBarTooltip
                currentStep={currentStep}
                bonus={bonus}
                totalSteps={stepsAmount}
                padding={
                  CUP_PADDINGS[Math.min(bonusIndex, CUP_PADDINGS.length - 1)]
                }
              />
            : null}
          </React.Fragment>
        )
      })}
    </Flex>
  )
}
